/**
 * Created by fers on 20/02/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import Breadcrumbs2 from 'react-router-breadcrumbs';
import Link from 'react-router/lib/Link';
import * as FeatureFlags from '../../common/util/FeatureFlags.ts';
import * as BrowserPermission from '../BrowserPermission';
import { getUISettings } from './UISettings.react.js';

const messages = defineMessages({
	home: {id: 'home', 'defaultMessage': 'Add-on homepage'}
});

interface BreadcrumbProps {
    intl?: object;
    params?: unknown[];
}

class Breadcrumb extends React.Component<BreadcrumbProps> {

    static propTypes = {
        intl: PropTypes.object,
        params: PropTypes.array,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        /* If we don't have router, we don't want to show breadcrumbs */
        if (!this.context.router) {
            return null;
        }

        /* For addon, we only want to show a link to the home page */
        if (getUISettings().isUpgatesAddon) {
            const params = new URLSearchParams();
            params.set('erp', getUISettings().erp);
            params.set('isUpgatesAddon', 'true');
            const baseUrl = `/organisations/${getUISettings().organisationId}/channels/${getUISettings().channelId}/${getUISettings().addonType}`;
            const url = `${baseUrl}?${params.toString()}`;
            const isHomePage = this.context.router.location.pathname === baseUrl;

            return (
                <div className="hidden-xs">
                    <ol className="breadcrumb">
                        <li>
                            {isHomePage ? (
                                <span className="addon-breadcrumb-inactive">{this.props.intl.formatMessage(messages.home)}</span>
                            ) : (
                                <Link to={url}>{this.props.intl.formatMessage(messages.home)}</Link>
                            )}
                        </li>
                    </ol>
                </div>
            );
        }

        let {params} = this.props;

        let args = {};

        if (params) {
			params.forEach((param) => {
				let metadata = param.type;
				let data = param.data;

				if (param.text) {
					args[metadata.entity() + ":view"] = param.text;
					return;
				}

                if (data) {
                    let defaultTitle = metadata.getDefaultTitle(data);

                    if (defaultTitle) {
                        args[metadata.entity() + ":view"] = defaultTitle;
                    }
                }
            });
        }

		// eslint-disable-next-line max-params
        const myLink = (link, key, text, index, routes) => {
            /* last item has invalid/duplicate name/link */
            if (text === undefined || (index === routes.length - 1 && text.length <= 1)) {
                return "";
            } else {
                let origText = text;

                return <li key={index}><Link key={key} title={origText} to={link}>{text.length > 50 ? <span>{text.substring(0, 40)}&hellip;</span> : text}</Link></li>;
            }
        };

		// eslint-disable-next-line max-params
        const myResolver = (key, text, routePath, route) => {
			if ((0 === key.indexOf('organisations:')) && !FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_CAN_SEE_ORGANISATIONS, BrowserPermission.getPermissionObject())) {
				return;
			}
            if (key === "ContainerConstructor") {
                return;
            }

            if (key === "⌂") {
                return key;
            }

            if (args[key]) {
                return args[key];
            }

            let s = key.split(":");

            if (s.length >= 2) {
                return this.props.intl.formatMessage({
                    id: "metadata." + s[0] + "." + s[1],
                    defaultMessage: "metadata." + s[0] + "." + s[1]
                });
            } else {
                return this.props.intl.formatMessage({
                    id: key,
                    defaultMessage: key
                });
            }
        };

        return (
            <div className="hidden-xs">
                <Breadcrumbs2
                              className="breadcrumb"
                              createLink={myLink}
                              createSeparator=""
                              params={this.context.router.params}
                              resolver={myResolver}
                              routes={this.context.router.routes}
                              wrappingComponent="ol" />
            </div>
        );
    }
}

export default injectIntl(Breadcrumb);
